import { PageRouteBuilder } from "@common/route/page-route-builder";
import { DeleteOrganisationPageComponent } from "./delete-organisation-page.component";

export const deleteOrganisationPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-delete-organisation-page", DeleteOrganisationPageComponent)
    .requiresLogin()
    .atUrl("/tools/delete-organisation")
    .withTitle("Delete Organisation")
    .build();
